import { action, observable } from 'mobx'
import { validationContext } from 'validx'
import { FilterEditorViewModelBase } from '@/features/legends/filters/FilterEditorViewModelBase'
import type { ConstantRule } from '@/features/legends/filters/rules'

/**
 * Always passes, or never does.
 */
export class ConstantEditorViewModel extends FilterEditorViewModelBase<ConstantRule> {
  readonly type = 'Constant'

  @observable accessor value = true

  readonly validation = validationContext(this, {})

  /**
   * Sets whether the filter passes.
   */
  @action.bound
  setValue(value: boolean) {
    this.value = value
  }

  /** @inheritDoc */
  @action
  hydrate({ value }: ConstantRule) {
    this.value = value !== false
  }

  /** @inheritDoc */
  toJSON(): ConstantRule {
    return { type: this.type, value: this.value }
  }
}
